import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { ZitadelUser } from "@src/types/user-management";

export interface GetUserResult {
  success: boolean;
  data?: ZitadelUser;
  error?: string;
}

export const getSingleUserUseCase = async (
  userId: string,
): Promise<GetUserResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.getUserById(namespace, userId);

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(
        error,
        "Failed to fetch users. Please try again later.",
      ).message,
    };
  }
};
